module.exports = __webpack_public_path__ + "static/img/swip.bdb2c1b0.png";